// extracted by mini-css-extract-plugin
export default {"librariesUpgradeAlert":"ZJ2W_1ZD5XAnnKIWXTv9"};